import chat from './sockets/chat'
import notices from './sockets/notices'
import invoices from './sockets/invoices'
import signalling from './sockets/signalling'
import notification from './sockets/notification'
import paypingConnected from './sockets/paypingConnected'
import role from './sockets/role'

export default socket => {
  chat(socket)
  notices(socket)
  invoices(socket)
  signalling(socket)
  notification(socket)
  paypingConnected(socket)
  role(socket)

  return socket
}
